export default "__VITE_ASSET__08aeae22__"